import { createActions } from '../helpers/redux';

export const InlineEditorActions = createActions({
  setInlineEditState(uid, value) {
    return { uid, value };
  },

  unsetInlineEditState(uid) {
    return { uid };
  },
});



// WEBPACK FOOTER //
// ./src/actions/inlineEditor.js